import { useEffect, useState } from "react";
import { useHttpAPI } from "../../../common/http/httpServiceAPI";
import { loadTranslationResources } from "../../../common/i18n/i18n";
import { useLocation } from 'react-router-dom';
import ExpiredLinkModal from "./ExpiredLinkModal/ExpiredLinkModal";

const TranslatedContentAPI = ({ children }) => {

  const http = useHttpAPI();
  const [translationsReady, setTranslationsReady] = useState(false);
  const [showLinkExpiredModal, setShowLinkExpiredModal] = useState(false);
  
  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  let query = useQuery();
  let contextIdFromUrl = query.get('ContextId');

  const closeExpiredLinkModal = () => {
    setShowLinkExpiredModal(false);
  }

  useEffect(() => {
    let expiredDateTimer = null;

    const loadTranslations = async() => {
      try {

        const results = await http.get('/TranslatableTextAPI?contextId=' + contextIdFromUrl);
        const timeToExpiration = await http.get(`/linkexpirationcheckapi?contextId=${contextIdFromUrl}`);
 
        if (timeToExpiration <= 0) {
          throw new Error('Link has expired');
        }
 
        loadTranslationResources(results);
        setTranslationsReady(true);
 
        expiredDateTimer = setTimeout(() => {
          setTranslationsReady(false);
          setShowLinkExpiredModal(true);
        }, timeToExpiration);
 
      } catch (error) {
        setShowLinkExpiredModal(true);
      }
    };
 
    loadTranslations();
 
    return () => {
      clearTimeout(expiredDateTimer);
    };
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contextIdFromUrl])

  return (
    <>
      {translationsReady && children}
      <ExpiredLinkModal
        visible={showLinkExpiredModal}
        onOk={closeExpiredLinkModal}
      />
    </>
  );
}

export default TranslatedContentAPI;